import { useEffect } from 'react';
import { Controller, UseFormReturn } from 'react-hook-form';
import { TextInput } from '@/schemas/sceneDataSchema';
import { TextField, FormControl } from '@mui/material';
import { encodeFieldKey } from '@/schemas/validation/ValidationSchemaGenerator';
import { useFieldBinding, seedFormFromStore } from '@/hooks/use-field-binding';

export const GenericInput = ({
  form,
  component,
  type = 'text',
}: {
  form: UseFormReturn;
  component: Omit<TextInput, 'type'>;
  type: string;
}) => {
  const key = encodeFieldKey(component);
  const binding = useFieldBinding(component, form);

  useEffect(() => {
    seedFormFromStore(form, key, binding.value);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Controller
      control={form.control}
      name={key}
      render={({ field, fieldState: { error } }) => (
        <FormControl
          fullWidth
          error={!!error}
        >
          <TextField
            type={type}
            label={component.label || 'Please enter'}
            variant='outlined'
            fullWidth
            role='textbox'
            error={!!error}
            placeholder={component.label || 'Please enter'}
            helperText={error ? error.message : component.description}
            {...field}
            onChange={(e) => {
              field.onChange(e);
              binding.sync(e.target.value);
            }}
            onBlur={() => {
              field.onBlur();
              binding.onBlur();
            }}
            value={(field.value as string) || ''}
          />
        </FormControl>
      )}
    />
  );
};
